import apiFetch from "@wordpress/api-fetch";
import {getRoute} from "./util";

export const doShippingAddressUpdate = ({address, payment_method, page_id}) => {
    return apiFetch({
        method: 'POST',
        url: getRoute('shipping-address'),
        data: {
            address,
            payment_method,
            page_id
        }
    });
}

export const doShippingRateChange = ({shipping_method, payment_method, page_id}) => {
    return apiFetch({
        method: 'POST',
        url: getRoute('shipping-method'),
        data: {
            shipping_method,
            payment_method,
            page_id
        }
    })
}